import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

import { FsPolicyGroup } from '../../models';
import { FsPolicyGroupService } from '../../services';

@Component({
  selector: 'fs-edit-policy-group-dialog',
  templateUrl: './edit-policy-group-dialog.component.html',
  styleUrls: ['./edit-policy-group-dialog.component.scss'],
})
export class EditPolicyGroupDialogComponent implements OnInit, OnDestroy {
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'name',
      type: 'input',
      templateOptions: {
        label: t('common.name'),
        type: 'text',
      },
    },
  ];

  public formModel: any = {
    policies: [],
  };

  private readonly _destroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FsPolicyGroup,
    private readonly _dialogRef: MatDialogRef<EditPolicyGroupDialogComponent>,
    private readonly _policyGroupService: FsPolicyGroupService,
  ) {}

  public ngOnInit(): void {
    this.formModel = this.data || this.formModel;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submit(): void {
    const request$ = this.formModel.id
      ? this._policyGroupService.update(this.formModel.id, this.formModel)
      : this._policyGroupService.create(this.formModel);
    request$.pipe(takeUntil(this._destroy$)).subscribe((group) => {
      this._dialogRef.close(group);
    });
  }
}
